
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[sangjo]/information",
      function () {
        return require("private-next-pages/[sangjo]/information.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[sangjo]/information"])
      });
    }
  